import React, { Component }                                      from "react"
import Responsive                                                from "react-responsive"
import { observer }                                              from "mobx-react"
import { Button, Container, Dropdown, Icon, Image, Menu, Modal } from "semantic-ui-react"
import { Link, NavLink }                                         from "react-router-dom"
import CartButton                                                from "components/Cart/CartButton"
import shop                                                      from "shop/shop"
import MenuBySlug                                                from "components/Menu/MenuBySlug"

import languageStore               from "stores/languageStore"
import app                         from "app.controller"
import "style/header.scss"
import searchStore                 from "stores/searchStore"
// import { SearchForm }              from "components/Search/SearchBarWithOptions"
import { SearchForm }              from "components/Search/SearchBarWithTypeahead"
import categoryStore               from "stores/categoryStore"
import { useLocation, withRouter } from "react-router"
import Typeahead                   from "../../../../components/Typeahead/Typeahead";

// import Navigation from "../Navigation/Navigation"
@observer
export default class Header extends Component {
  
  constructor() {
    super()
    this.state = {
      list: shop.orderlist.default,
      categoryData: false
    }
  }
  
  componentDidMount() {
    shop.events.loaded.add( this.handleLoad )
    shop.orderlist.default.events.change.add( this.handleOrderlist )
  }
  
  handleOrderlist = ( { list } ) => {
    this.setState( {
                     list
                   } )
  }
  
  handleLoad = () => {
    this.setState( {
                     categoryData: shop.categories
                   } )
  }
  
  componentWillUnmount() {
    shop.orderlist.default.events.change.remove( this.handleOrderlist )
    shop.events.loaded.remove( this.handleLoad )
  }
  
  render() {
    const { showMini } = this.state
    return (
      <header className={`header ${showMini}`}>
        <Responsive maxWidth={790}>
          <div>
            {showMini && <MiniHeaderMobile/>}
            <OnOffset
              offset={95}
              onPassedReverse={() => {
                this.setState( { showMini: false } )
              }}
              onPassed={() => {
                console.log( "scrolled" )
                this.setState( { showMini: "scrolled" } )
              }}>
              <MobileHeader/>
            </OnOffset>
          </div>
        </Responsive>
        <Responsive minWidth={790}>
          <div>
            {showMini && <MiniHeader/>}
            <OnOffset
              offset={95}
              onPassedReverse={() => {
                this.setState( { showMini: false } )
              }}
              onPassed={() => {
                console.log( "scrolled" )
                this.setState( { showMini: "scrolled" } )
              }}>
              <DesktopHeader/>
            </OnOffset>
          </div>
        </Responsive>
      </header>
    )
  }
}

class MobileHeader extends Component {
  render() {
    const { inverted = false } = this.props
    return (
      <div className="MobileHeader">
        <div className="pa2 ph2 ph4-ns pa3-ns">
          <div className="flex flex-row justify-between items-center">
            <div className={"w-100 flex flex-row justify-start"}>
              <Button basic inverted={inverted} icon="bars" onClick={app.sidebarLeft.toggle.dispatch}/>
              <SettingsModal inverted={inverted}/>
              <Button basic inverted={inverted} icon="search" as={Link} to={"/search/"}/>
            </div>
            
            <div className={"w-100 flex flex-row items-center justify-center"}>
                              <NavLink to="/home/" className={"Logo"}>
                  <img style={{maxHeight: "70px", maxWidth: "80px"}}
                    src={shop.config.logo}
                    alt="zur Startseite"/>
                </NavLink>
            </div>
            
            <div className={"w-100 flex flex-row justify-end items-center"}>
              {/*<Search />*/}
              
              <CartButton inverted={inverted}/>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


const SettingsModal = ( { inverted } ) => {
  return (
    <Modal  trigger={<Button basic inverted={inverted} icon="settings"/>}>
      <Modal.Content>
        <SettingsMenu vertical/>
      </Modal.Content>
    </Modal>
  )
}


const SettingsMenu = observer(
  ( props ) => {
    const { currentLanguage } = languageStore
    return (
      <Menu secondary
            borderless
            fluid
            {...props}
            size="small">
        
        {/* LEFT SIDE MENU */}
        {shop.session && <Menu.Item
          position="right"
          as={Link}
          to="/orderlist/"><Icon name={"heart"}/> {translate( "Orderlist" )}</Menu.Item>}
        
        {/* RIGHT SIDE MENU*/}
        
        {(shop.session && shop.session.handId) && <Menu.Item
          as={Link}
          to="/login/accounts/">{translate( "Clients" )}</Menu.Item>}
        {shop.session && <Menu.Item
          as={Link}
          to="/quickorder/"><Icon name={"shopping basket"}/>{translate( "Quickorder" )}</Menu.Item>}
        
        {shop.session && <Menu.Item
          as={Link}
          to="/account/"><Icon name={"user"}/>{translate( "My Account" )}</Menu.Item>}
        {shop.session && <Menu.Item
          as={Link}
          to="/logout/"><Icon name={"power off"}/>{translate( "Logout" )}</Menu.Item>}
        
        {!shop.session && <LoginLink/>}
        {languageStore.available.length > 1 && <Dropdown text={currentLanguage.toUpperCase()}
                                                         pointing
                                                         className="link item">
          <Dropdown.Menu>
            {languageStore.available.map( locale => <Dropdown.Item
              key={locale}
              onClick={() => languageStore.setLanguage( locale )}>{locale}</Dropdown.Item> )}
          </Dropdown.Menu>
        </Dropdown>}
      </Menu>
    )
  }
)

function LoginLink() {
  const location = useLocation()
  return <Menu.Item
    position="right"
    as={Link}
    to={`/login?referrer=${location.pathname + location.search}`}><Icon name={"power on"}/>{translate( "Anmelden" )}</Menu.Item>
}

@observer
class DesktopHeader extends Component {
  render() {
    return (
      <div >
        <div className="top-menu-mini absolute primary top-0 left-0 right-0 z-3" >
        <div className="headerColorScheme"></div>
          <div className="flex flex-row justify-between items-center" >
            {/*            <a className={"f5 ph3 pv2 primary"} href={"//lindt.de/"}>
              <div className="nowrap primary"><Icon icon="chevron left"/> {translate( "zurück zur Lindt.de" )}</div>
            </a> */}
            <SettingsMenu  attached/>
          </div>
        </div>
        
        <OnOffset
          offset={95}
          onPassedReverse={() => {
            this.setState( { showMini: false } )
          }}
          onPassed={() => {
            this.setState( { showMini: "scrolled" } )
          }}>
          <div className="top-menu bg-white " style={{zIndex: 100, minHeight: "150px"}}>
            <Container className="relative" style={{  }}>
              <div className="logoHeader" >
                {/*<Responsive maxWidth={1298}><Button icon="bars" onClick={app.sidebarLeft.toggle.dispatch}/></Responsive>*/}
                <NavLink to="/home/" className={"Logo"}>
                  <img
                    src={shop.config.logo}
                    alt="zur Startseite"/>
                </NavLink>
                {/*<Button basic> DE <Icon name="caret down"/></Button>*/}
              </div>
              
              
              <div className="absolute right-0 top-0 mt1">

                <MenuBySlug style={{ zIndex: 100}}
                  key={"mini-header"}
                  slug={"header"}
                  secondary
                  borderless>
                                  <Menu.Item>
                            <div style={{maxWidth: "400px", zIndex: 101}} className="  ba b--black-10 pa2 ma2">
              <p className="f6 fw6"> {translate("Bitte wenden Sie sich bei Rückfragen oder Display-Bestellungen direkt an unsere Customer-Sales-Abteilung.")} </p>
              <p className="f6 fw6"> {translate("Telefon")}: 0241-8881-7703 <br/>
               {translate("E-Mail")}: customer-sales-de@lindt.com </p>
              </div>
              </Menu.Item>

                  {/*!shop.session && <Menu.Item className={"primary"} as={Link} to={`/login/?referrer=${document.location.pathname}`}>{translate( "Anmelden" )}</Menu.Item>*/}
                  {/*!shop.session && <Menu.Item className={"primary"}><Button as={Link} to={`/login/?referrer=${document.location.pathname}`} primary>{translate( "Bestandskunden: Anmelden" )}</Button>&nbsp;&nbsp;
                  <Button as={Link} to={"/customer_registration/"}  className="buttonFade" >{translate( "Neukunden: Registrieren" )}</Button></Menu.Item>}
                  {/*!shop.session && <Menu.Item className="buttonFade" as={Link} to={"/customer_registration/"}>{translate( "Nekunden: Registrieren" )}</Menu.Item>*/}
                  {shop.session && <Menu.Item><CartButton/></Menu.Item>}
                  <Menu.Item>
                    <div className="flex flex-row items-center ba b--black-10" style={{ borderRadius: "25px", overflow: "hidden" }}>
                      <SearchForm
                        style={{ width: "170px" }}
                        className={"mw6 w-100"}
                        value={searchStore.searchTerm}
                        onChange={e => {
                          searchStore.setSearchTerm( e.target.value )
                        }} icon="search" placeholder={translate( "Suche" ) + "..."}/>
                    </div>
                  </Menu.Item>
                  
                  <Responsive maxWidth={768}><Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon
                    name="bars"/></Menu.Item>
                  </Responsive>
                </MenuBySlug>
                {/*{!shop.session && <div><Link to="/login">Anmelden</Link> oder <Link to="/customer_registration">Registrieren</Link></div>}*/}
              </div>
              
              <div className="tc pb3">
                <div className="logo--shop block">
                </div>
              </div>
              {/*<Menu slug="menu-en"/>*/}
            </Container>

          </div>
        </OnOffset>
        {/*<MenuUtility list={list}/>*/}
        <MegaMenuBig/>
                        {/*        <div className="TopBotMenufrankenstolz"></div>
        
        <div className="TopBotMenufrankenstolz"></div> */}
      </div>
    )
  }
}

const MiniHeaderMobile = () => <div
  className="mini-header z-9 fixed top-0 left-0 right-0   bg-white animate  fadeInDown">
  <div className="ph2">
    <Menu borderless
          secondary>
      <Menu.Item onClick={app.sidebarLeft.toggle.dispatch}><Icon name="bars"/></Menu.Item>
      {/*<Menu.Item><SettingsButton/></Menu.Item>*/}
      <Menu.Item as={Link} to="/orderlist/" position="right"><Icon name="like"/></Menu.Item>
      <Menu.Item
        as={Link}
        to="/search/"><Icon name="search"/></Menu.Item>
      {shop.session && <Menu.Item><CartButton/></Menu.Item>}
    </Menu>
  </div>
</div>


const MiniHeader = () => <div className="mini-header z-9 fixed top-0 left-0 right-0   bg-white animate  fadeInDown">
  <div className="ph2">
    <MenuBySlug slug={"header"}
                key={"mini-header-main"}
                secondary
                borderless>
      <Menu.Item
        position="right"
        content={translate( "Orderlist" )}
        as={Link}
        to="/orderlist/"/>
      <Menu.Item
        as={Link}
        to="/search/"><Icon name="search"/></Menu.Item>
      {shop.session && <Menu.Item><CartButton/></Menu.Item>}
    </MenuBySlug>
  </div>
</div>


class OnOffset extends Component {
  
  state = {
    passed: false
  }
  
  componentDidMount() {
    window.addEventListener( "scroll", this.handleScroll )
    this.handleScroll()
  }
  
  componentWillUnmount() {
    window.removeEventListener( "scroll", this.handleScroll )
  }
  
  handleScroll = () => {
    let { passed } = this.state
    let { pageYOffset } = window
    if ( pageYOffset > this.props.offset ) {
      if ( !passed ) {
        this.setState( { passed: true } )
        this.props.onPassed && this.props.onPassed()
      }
    } else {
      if ( passed ) {
        this.setState( { passed: false } )
        this.props.onPassedReverse && this.props.onPassedReverse()
      }
    }
  }
  
  render() {
    return this.props.children || null
  }
}


@observer
class MegaMenu extends Component {
  
  state = {
    hover: false,
    index: false
  }
  
  onLeave = () => {
    this.setState( { hover: false } )
    window.setTimeout( () => {
      let { hover } = this.state
      if ( !hover ) this.setState( { index: false } )
    }, 200 )
  }
  
  onHover = ( { index } ) => {
    this.setState( { index, hover: true } )
  }
  
  render() {
    const { categories } = categoryStore
    const { index } = this.state
    const category = shop.categoriesById.get( index )
    
    return <div className="MegaMenu bg-blue relative" style={{ zIndex: 99 }}>
      <Container className="">
        <div className="pb2">
          {categories.length > 0 && <div>
            <Menu inverted attached="bottom" fluid stackable secondary widths={categories.length}>
              {categories.map( category => {
                
                                 if ( category.children.length === 0 ) {
                                   return <Menu.Item as={NavLink} to={`/collection/${category.map_id}/`}>{category.title}</Menu.Item>
                                 }
                
                                 return <Dropdown key={category.map_id} item text={category.title}>
                                   <Dropdown.Menu>
                                     <Menu.Item as={NavLink} to={`/collection/${category.map_id}/`}><b>{category.title}</b></Menu.Item>
                                     {category.children.map( category => {
                                       return <Dropdown.Item as={Link} to={`/collection/${category.map_id}/`}
                                                             key={category.map_id}>{category.title}</Dropdown.Item>
                                     } )}
                                   </Dropdown.Menu>
                                 </Dropdown>
                               }
              )}
            </Menu>
          
          </div>
          }
        
        
        </div>
      
      </Container>
    </div>
  }
}


let isHovering = false

@observer
@withRouter
export class MegaMenuBig extends Component {
  
  state = {
    hover: false,
    index: false,
  }
  
  onLeave = () => {
    isHovering = false
    this.setState( { hover: false } )
    window.setTimeout( () => {
      let { hover } = this.state
      if ( !hover ) this.setState( { index: false } )
    }, 120 )
  }
  
  onHover = ( { index } ) => {
    const DELAY = 300
    isHovering = true
    window.setTimeout( () => {
      if ( isHovering ) this.setState( { index, hover: true } )
    }, DELAY )
  }
  
  render() {
    const { categories } = categoryStore
    const { index } = this.state
    const selectedCategory = shop.categoriesById.get( index )
    return <div
      onMouseLeave={this.onLeave}

      className="headerColorScheme relative" style={{color: "#1f6056;", zIndex: 99 }}>
      <Container className="">
        <div className="TopMenuOrtho"></div>
        <div className="">
          {categories.length > 0 &&
            <div className={"tc flex flex-row f2 justify-start items-center flex-wrap space-around"}>
              {categories
                .map( category => {
                  // console.log( document.location.pathname, `/collection/${category.map_id}/` )
                  const active = document.location.pathname.startsWith( `/collection/${category.map_id}/` ) || selectedCategory && selectedCategory.map_id === category.map_id
                  return <Link key={category.map_id}
                               onClick={() => {
                                 this.setState( { index: false, hover: false } )
                               }}
                               className={` db pv3  f2 white nowrap flex-grow-1 fw5 hover-silver space-around  ${active ? "active" : ""}`}
                               onMouseEnter={( e ) => this.onHover( { index: category.map_id } )}
                               to={`/collection/${category.map_id}/`}><span className="dib pr2 f5">{category.title}
                               {/*^className={` db pv3 pl6 pr4 f2 white nowrap hover-primary space-around  ${active ? "active" : ""}`}*/}
                    {/*<span className="red">({category.sort})</span>*/}
											 </span>
                  </Link>
                } )
              } </div>
              
          }
             <div className="BotMenuOrtho"></div>         
        </div>
        
        {/*selectedCategory && <Container
          style={{ padding: 0 }}
          onMouseLeave={this.onLeave}
          className=" absolute bg-dark left-0 right-0 z-999 animate fadeIn">
          <div>
            <div className="flex flex-row justify-between bg-black-10">
              <Link className={"db pa3 f6 ph4 white nowrap fw4 hover-primary b f6"} onClick={this.onLeave} to={`/collection/${selectedCategory.map_id}/`}>
                {selectedCategory.title} <Icon name={"chevron right"}/></Link>
              <Button className={"white pointer pa3 icon-button"} onClick={this.onLeave} icon={"times"}/>
            </div>
            <div className="pa4-ns pa3 pb4">
              <div className="flex flex-row flex-wrap ">
                {selectedCategory.children.map( subCategory => {
                  const active = document.location.pathname.startsWith( `/collection/${selectedCategory.map_id}/${subCategory.map_id}/` )
                  return <div className="pr4 pb4 " key={subCategory.map_id}>
                    
                    {/*LEVEL II }
                    <Link
                      onClick={() => {
                        this.setState( { index: false, hover: false } )
                      }}
                      className={`db f6 pv2 pb3 b white nowrap fw5 hover-primary ${active ? "active" : ""}`}
                      to={`/collection/${selectedCategory.map_id}/${subCategory.map_id}/`}
                    ><b>{subCategory.title}
                      {/*<span className="red">({subCategory.sort})</span>}
                    </b></Link>
                    {/*LEVEL III}
                    {subCategory.children.map( c => <Link
                      key={c.map_id}
                      onClick={() => {
                        this.setState( { index: false, hover: false } )
                      }}
                      className={`db f6 pv1 pb2 white-80 nowrap fw4 hover-primary ${active ? "active" : ""}`}
                      to={`/collection/${selectedCategory.map_id}/${c.map_id}/`}
                    >{c.title}
                      {/*<span className="red">({c.sort})</span>}
                    </Link> )}
                  </div>
                } )}
              </div>
            </div>
          </div>
              </Container>*/}
      </Container>
    </div>
  }
}





// WEBPACK FOOTER //
// ./src/theme/lindtbShop/components/Header/Header.js